import {serviceApiHostName} from "../../endpoint";
import {defaultHeaders} from "../../headers";

export const deleteAttachment = async (key) => {
  try {
    const result = await fetch(
      `${serviceApiHostName}/service/attachment/delete`,
      {
        method: "PUT",
        headers: {
          ...defaultHeaders,
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
        body: JSON.stringify({key}),
      }
    );
    return {
      hasSuccess: result.status === 200,
      data: await result.json(),
    };
  } catch (err) {
    return {
      hasSuccess: false,
      data: err.message,
    };
  }
};
